<template>
  <v-app>
    <!-- NavigationBar always appears.
         When no user is logged in, it shows only the Login button. -->
    <NavigationBar 
      :user="user" 
      @logout="handleLogout" 
      @bar-switched="handleBarSwitched" 
    />
    <v-main>
      <!-- Components should emit "login-success" on a successful login -->
      <router-view @login-success="handleLoginSuccess" />
    </v-main>
  </v-app>
</template>

<script>
import { useUserStore } from "./stores/user";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import NavigationBar from "./components/NavigationBar.vue";
import { watch } from "vue";

export default {
  components: {
    NavigationBar,
  },
  setup() {
    const userStore = useUserStore();
    const router = useRouter();
    const { user } = storeToRefs(userStore);
    // Dynamic tab title
    watch(user, (u) => {
      const base = 'Star Group';
      if (!u || u.is_vip) {
        document.title = base;
      } else {
        const bar = u.active_bar || u.bar;
        document.title = `${base} - ${bar}`;
      }
    }, { immediate: true, deep: true });
    // On login-success, re-fetch the user.
    function handleLoginSuccess() {
      userStore.fetchUser();
    }
    // After logout, clear the user state and send the user back to the homepage.
    async function handleLogout() {
      await userStore.logout();
      router.push("/"); // Redirect to homepage (which redirects to /home per your router)
    }
    function handleBarSwitched(newBar) {
      userStore.switchBar(newBar);
    }
    
    return {
      user,
      handleLoginSuccess,
      handleLogout,
      handleBarSwitched,
    };
  }
};
</script>
